import React from 'react'
import UserSettingsShell from '@/modules/user-settings/components/UserSettingsShell'
import UserRegionSettingsCard from '@/modules/user-settings/components/UserRegionSettingsCard'
import UserNotificationsSection from '@/modules/user-settings/components/UserNotificationsSection'

export default function MemberUserSettingsPage() {
  return (
    <div className="w-full">
      <h1 className="mb-4 text-2xl font-semibold">Configurações</h1>
      <UserSettingsShell
        items={[
          { key: 'region', label: 'Localização e horário', render: () => <UserRegionSettingsCard /> },
          { key: 'notifications', label: 'Notificações', render: () => <UserNotificationsSection /> },
        ]}
      />
    </div>
  )
}

